import React, { useEffect, useState } from 'react';
import { Footer } from '../../components/footer';
import { useProfileDetails } from '../profile-details/api/profileapi';
import { CountryFile } from '../profile-details/country';
import { useNavigate } from 'react-router-dom';
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useToast } from '../../hook/usetoast';
import { Check } from 'lucide-react';
import profileImage from '../../assets/images/useruploadImg.png'
import { useEliteClub } from './stakingwallet/api';
import { useModalContext } from '../../contexts/ModalContext';
import { useMetamaskDisconnect } from '../home/api/api';
import { useUserTotalStake } from './redeem/api';
import { useAppKitAccount, useDisconnect } from '@reown/appkit/react';

const ProfilePage = () => {
  const { address } = useAppKitAccount();
  const toast = useToast()
  const { data: profileData } = useProfileDetails()
  const [country, setCountry] = useState()
  const [done, setDone] = useState(false)
  const [done1, setDone1] = useState(false)
    const { data: eliteClub } = useEliteClub()
  const { setIsloadingconnect } = useModalContext()
  const { disconnect } = useDisconnect();
        const userDisconnect = useMetamaskDisconnect()
  const { data: totalTeam } = useUserTotalStake()

  const navigate = useNavigate()
  useEffect(() => {
    const country = CountryFile.find(o => o.code === profileData?.country);
    setCountry(country?.name)
  }, [profileData])
  const copyuserAddress = async data => {
    setDone(data)
    await copyToClipboard(`https://thepillcoin.com/${data}`)
    toast.success("Referral link is copied")
    setTimeout(() => {
      setDone()
    }, 800)
  }
  const copyuserAddress1 = async data => {
    setDone1(data)
    await copyToClipboard(data)
    toast.success("Address is copied")
    setTimeout(() => {
      setDone1()
    }, 800)
  }
  const copyUserId = async data => {
    setDone(data)
    await copyToClipboard(data)
    toast.success("ID is copied")
    setTimeout(() => {
      setDone()
    }, 800)
  }
  const logout = async () => {
    setIsloadingconnect(true)
    const res = await userDisconnect.mutateAsync({ address: address?.toLowerCase() })
    if (res?.status) {
      disconnect();
        localStorage.removeItem("account")
        sessionStorage.removeItem('user_JWT')
        navigate('/')
        toast.error("Wallet disconnected successfully");
        setIsloadingconnect(false)
      

    }

};
  return (
    <>
      <div className="mainContent">
        <div className="pageContent def-py-30">
          <div className='container'>
            <div className="appPagetitle">Profile</div>
            <div className="row">
              <div className="col-lg-12">
                <div className="appcard mb-4">
                  <div className="cardHeader d-flex justify-content-between flex-wrap">
                    <div className='bxTitle'>
                      <img src={require('../../assets/images/dashboard/profileImg.svg').default} alt='walletImg.svg' />
                      <span>Profile</span>
                    </div>

                  </div>
                  <div className="row align-items-center">
                    <div className="col-lg-4 mb-3">
                      <div className="d-flex align-items-center g-15">
                        <div className='userImgUpload'>
                          <div className='userImgBorder'>
                            <img src={profileData?.profileImage || profileImage} alt='userImg' className='img-fluid' />
                          </div>
                        </div>
                        <div>
                          <div className='pro-name mb-2'>{profileData?.username}</div>
                          
                          <div className='pro-id'>ID <span className='fw-600 text-white'>{profileData?.userId ? profileData?.userId : "---"}
                            {done === profileData?.userId ? <Check size={20} className="ml-5" /> : <button className='btn btnEmpty' onClick={() => copyUserId(profileData?.userId)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7 9.667C7 8.95967 7.28099 8.28131 7.78115 7.78115C8.28131 7.28099 8.95967 7 9.667 7H18.333C18.6832 7 19.03 7.06898 19.3536 7.20301C19.6772 7.33704 19.9712 7.53349 20.2189 7.78115C20.4665 8.0288 20.663 8.32281 20.797 8.64638C20.931 8.96996 21 9.31676 21 9.667V18.333C21 18.6832 20.931 19.03 20.797 19.3536C20.663 19.6772 20.4665 19.9712 20.2189 20.2189C19.9712 20.4665 19.6772 20.663 19.3536 20.797C19.03 20.931 18.6832 21 18.333 21H9.667C9.31676 21 8.96996 20.931 8.64638 20.797C8.32281 20.663 8.0288 20.4665 7.78115 20.2189C7.53349 19.9712 7.33704 19.6772 7.20301 19.3536C7.06898 19.03 7 18.6832 7 18.333V9.667Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M4.012 16.737C3.70534 16.5622 3.45027 16.3095 3.27258 16.0045C3.09488 15.6995 3.00085 15.353 3 15V5C3 3.9 3.9 3 5 3H15C15.75 3 16.158 3.385 16.5 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            </button>}

                          </span></div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8 mb-3">
                      <div className='d-flex g-15 align-items-center justify-content-lg-end flex-wrap'>
                        <span className='dashboardLabelbx lh-25 def-py-9'>Referred By <span className="text-white">{profileData?.refferdByUserId}</span></span>
                        <button className='btn btn-secondary px-4 def-py-9 lh-25' onClick={() => navigate('/profile-details')}>Update Profile</button>
                        <button className='btn btnlogout px-lg-5 px-4 def-py-9 lh-25' onClick={logout}>Logout</button>

                      </div>
                    </div>

                  </div>

                  <div className="row  border-top pt-4">
                    <div className="col-lg-4">
                      <div className="proDetails">
                        <div className='pd-icon'>
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.25 5.25C2.25 4.85218 2.40804 4.47064 2.68934 4.18934C2.97064 3.90804 3.35218 3.75 3.75 3.75H14.25C14.6478 3.75 15.0294 3.90804 15.3107 4.18934C15.592 4.47064 15.75 4.85218 15.75 5.25V12.75C15.75 13.1478 15.592 13.5294 15.3107 13.8107C15.0294 14.092 14.6478 14.25 14.25 14.25H3.75C3.35218 14.25 2.97064 14.092 2.68934 13.8107C2.40804 13.5294 2.25 13.1478 2.25 12.75V5.25Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2.25 5.25L9 9.75L15.75 5.25" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                        <div>
                          <div className='pd-label'>Email Address</div>
                          <div className='pd-value'>{profileData?.email}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="proDetails justify-content-lg-center">
                        <div className='pd-icon'>
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.75 3H6.75L8.25 6.75L6.375 7.875C7.17822 9.50365 8.49635 10.8218 10.125 11.625L11.25 9.75L15 11.25V14.25C15 14.6478 14.842 15.0294 14.5607 15.3107C14.2794 15.592 13.8978 15.75 13.5 15.75C10.5744 15.5722 7.81512 14.3299 5.74262 12.2574C3.67013 10.1849 2.42779 7.42555 2.25 4.5C2.25 4.10218 2.40804 3.72064 2.68934 3.43934C2.97064 3.15804 3.35218 3 3.75 3Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                        <div>
                          <div className='pd-label'>Phone Number</div>
                          <div className='pd-value'>{profileData?.dial_code} {profileData?.mobile}</div>
                          <div className='pd-label'></div>
                          <div className='pd-value'></div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 ">
                      <div className="proDetails justify-content-lg-end">
                        <div className='pd-icon'>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z" stroke="#E3E4E4" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M3.6 9H20.4" stroke="#E3E4E4" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M3.6 15H20.4" stroke="#E3E4E4" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M11.5 3C9.81534 5.69961 8.9222 8.81787 8.9222 12C8.9222 15.1821 9.81534 18.3004 11.5 21" stroke="#E3E4E4" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.5 3C14.1847 5.69961 15.0778 8.81787 15.0778 12C15.0778 15.1821 14.1847 18.3004 12.5 21" stroke="#E3E4E4" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                        <div>
                          <div className='pd-label'>Country</div>
                          <div className='pd-value'>{country}</div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="row form-row">
                    <div className="col-lg-2">
                      <div className='appDarkCard walletCard py-3 mb-4 mb-lg-0'>
                        <div className='wc-img mb-1'>
                          <span className='wcImg-circle'>
                            <img src={require('../../assets/images/dashboard/profilegroup.svg').default} alt='iconwc' />
                          </span>
                        </div>
                        <div className='wc-name'>Direct Members</div>
                        <div className='wc-value'>
                          <span className=''>{profileData?.directMembers ? profileData?.directMembers : 0}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-5 mb-3 mb-lg-0">
                      <div className='appDarkCard h-100'>
                        <div className='fs-14 fw-400 text-white-60 mb-2 pt-3'>Referral Link </div>
                        <div className='copyIdBx'>
                          <span>{profileData?.refferCode ? `https://thepillcoin.com//${profileData?.refferCode}` : "---"}</span>
                          {done === profileData?.refferCode ? <Check size={20} className="ml-5" /> : <button className='btn btnEmpty' onClick={() => copyuserAddress(profileData?.refferCode)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7 9.667C7 8.95967 7.28099 8.28131 7.78115 7.78115C8.28131 7.28099 8.95967 7 9.667 7H18.333C18.6832 7 19.03 7.06898 19.3536 7.20301C19.6772 7.33704 19.9712 7.53349 20.2189 7.78115C20.4665 8.0288 20.663 8.32281 20.797 8.64638C20.931 8.96996 21 9.31676 21 9.667V18.333C21 18.6832 20.931 19.03 20.797 19.3536C20.663 19.6772 20.4665 19.9712 20.2189 20.2189C19.9712 20.4665 19.6772 20.663 19.3536 20.797C19.03 20.931 18.6832 21 18.333 21H9.667C9.31676 21 8.96996 20.931 8.64638 20.797C8.32281 20.663 8.0288 20.4665 7.78115 20.2189C7.53349 19.9712 7.33704 19.6772 7.20301 19.3536C7.06898 19.03 7 18.6832 7 18.333V9.667Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M4.012 16.737C3.70534 16.5622 3.45027 16.3095 3.27258 16.0045C3.09488 15.6995 3.00085 15.353 3 15V5C3 3.9 3.9 3 5 3H15C15.75 3 16.158 3.385 16.5 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>}

                        </div>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className='appDarkCard h-100'>
                        <div className='fs-14 fw-400 text-white-60 mb-2 pt-3'>Wallet Address </div>
                        <div className='copyIdBx'>
                          <span>{address}</span>
                          {done1 === address ? <Check size={20} className="ml-5" /> : <button className='btn btnEmpty' onClick={() => copyuserAddress1(address)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7 9.667C7 8.95967 7.28099 8.28131 7.78115 7.78115C8.28131 7.28099 8.95967 7 9.667 7H18.333C18.6832 7 19.03 7.06898 19.3536 7.20301C19.6772 7.33704 19.9712 7.53349 20.2189 7.78115C20.4665 8.0288 20.663 8.32281 20.797 8.64638C20.931 8.96996 21 9.31676 21 9.667V18.333C21 18.6832 20.931 19.03 20.797 19.3536C20.663 19.6772 20.4665 19.9712 20.2189 20.2189C19.9712 20.4665 19.6772 20.663 19.3536 20.797C19.03 20.931 18.6832 21 18.333 21H9.667C9.31676 21 8.96996 20.931 8.64638 20.797C8.32281 20.663 8.0288 20.4665 7.78115 20.2189C7.53349 19.9712 7.33704 19.6772 7.20301 19.3536C7.06898 19.03 7 18.6832 7 18.333V9.667Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M4.012 16.737C3.70534 16.5622 3.45027 16.3095 3.27258 16.0045C3.09488 15.6995 3.00085 15.353 3 15V5C3 3.9 3.9 3 5 3H15C15.75 3 16.158 3.385 16.5 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="appcard mb-4">
                  <div className="cardHeader d-flex justify-content-between flex-wrap">
                    <div className='bxTitle mb-3 mb-md-0'>
                      <span>Global Reward  My Achievement</span>
                    </div>
                    <div className='d-flex g-15 align-items-center'>
                      <span className='dashboardLabelbx'>ELITE CLUB <span className={eliteClub?.status ? 'text-lightgreen' : 'text-lightred'}>{eliteClub?.status ? 'Achieved' : 'Not Achieved'}</span></span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-6 mb-3 mb-lg-0">
                      <div className='borderRightprofilebx'>
                        <div className="fs-14 fw-400 text-white-60">Direct Members</div>
                        <div className="fs-20 fw-700">{profileData?.directMembers ? profileData?.directMembers : 0}</div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 mb-3 mb-lg-0">
                      <div className='pl-lg-5 borderRightprofilebx'>
                        <div className="fs-14 fw-400 text-white-60">Self Stake</div>
                        <div className="fs-20 fw-700">{totalTeam?.totalUserStake?.activeStake}</div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 mb-3 mb-sm-0">
                      <div className='pl-lg-5 borderRightprofilebx'>
                        <div className="fs-14 fw-400 text-white-60">Team Count</div>
                        <div className="fs-20 fw-700">{totalTeam?.teamCount}</div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <div className='pl-lg-5'>
                        <div className="fs-14 fw-400 text-white-60">Team Stake Active</div>
                        <div className="fs-20 fw-700">{totalTeam?.teamStake}</div>
                      </div>
                    </div>
                  </div>

                </div>

                <div className="appcard mb-4">
                  <div className="cardHeader">
                    <div className='bxTitle'>
                      <span>Global Reward  Eligibility Criteria</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-6 mb-3 mb-lg-0">
                      <div className='borderRightprofilebx'>
                        <div className="fs-14 fw-400 text-white-60">Direct Members</div>
                        <div className="fs-20 fw-700">{profileData?.directMembers ? profileData?.directMembers : 0}</div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 mb-3 mb-lg-0">
                      <div className='pl-lg-5 borderRightprofilebx'>
                        <div className="fs-14 fw-400 text-white-60">Self Stake</div>
                        <div className="fs-20 fw-700">{totalTeam?.globalReward?.selfstake}</div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 mb-3 mb-md-0">
                      <div className='pl-lg-5 borderRightprofilebx'>
                        <div className="fs-14 fw-400 text-white-60">Team Count</div>
                        <div className="fs-20 fw-700">{totalTeam?.globalReward?.teamcount} (10 Level)</div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                      <div className='pl-lg-5'>
                        <div className="fs-14 fw-400 text-white-60">Team Stake Active</div>
                        <div className="fs-20 fw-700">{totalTeam?.globalReward?.teamstake}</div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default ProfilePage